<template>
  <div>
    <portal></portal>
  </div>
</template>

<script>
import Portal from './Portal'

export default {
  name: 'Analysis',
  components: {
    Portal
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>
